<template>
  <div>
    <b-alert :show="status != 'COMPLETED'">
      {{$t('scheduler.statistics_not_available')}}
    </b-alert>
    <div v-if="status == 'COMPLETED'">
      <div class="row">
        <div class="col-12 col-lg-4 p-relative">
          <Doughnut
            chart-id="total-delivered"
            dataset-id-key="label"
            :height="420"
            :chart-options="chartOptions"
            :chart-data="chartData"
          />
          <div class="donut-inner text-center">
            <h5>{{$t('scheduler.delivered_messages')}}</h5>
            <span>{{statistics.messagesDelivered}}/{{statistics.totalPersons}}</span>
          </div>
          <h5 class="mt-1 text-center">{{ percentDelivered }}%</h5>
        </div>

        <div class="col-12 col-lg-8 p-relative">
          <div class="row justify-content-around">
            <div class="col-12 col-md-5 mt-4">
              <Doughnut
                chart-id="engaged-persons"
                dataset-id-key="label"
                :height="150"
                :chart-options="smallChartOptions"
                :chart-data="chartEngagedPersonsData"
              />
              <h2 class="mt-n5 text-center">{{engagedPersons}}</h2>
              <h5 class="mt-3 text-center">{{$t('scheduler.marketable')}}</h5>
            </div>
            <div class="col-12 col-md-5 mt-4">
              <Doughnut
                chart-id="not-delivered"
                dataset-id-key="label"
                :height="150"
                :chart-options="smallChartOptions"
                :chart-data="chartNotDeliveredData"
              />
              <h2 class="mt-n5 text-center">{{notDelivered}}</h2>
              <h5 class="mt-3 text-center">{{$t('scheduler.not_delivered')}}</h5>
            </div>
          </div>

          <div class="row justify-content-around">
            <div class="col-12 col-md-5 mt-4">
              <Doughnut
                chart-id="out-opted"
                dataset-id-key="label"
                :height="150"
                :chart-options="smallChartOptions"
                :chart-data="optedOutPersonsChartData"
              />
              <h2 class="mt-n5 text-center">{{statistics.optedOutPersons}}</h2>
              <h5 class="mt-3 text-center">{{$t('scheduler.opted_out')}}</h5>
            </div>

            <div class="col-12 col-md-5 mt-4">
              <Doughnut
                chart-id="invalid-number"
                dataset-id-key="label"
                :height="150"
                :chart-options="smallChartOptions"
                :chart-data="chartInvalidNumbersData"
              />
              <h2 class="mt-n5 text-center">{{statistics.totalInvalidNumbers}}</h2>
              <h5 class="mt-3 text-center">{{$t('scheduler.invalid_numbers')}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  components: {
    Doughnut
  },
  props: {
    status: {
      type: String,
      default: null,
    },
    statistics: {
      type: Object,
      default: null,
    },
  },
  computed: {
    notDelivered() {
      return this.statistics.totalPersons - this.statistics.messagesDelivered;
    },
    engagedPersons() {
      return this.statistics.messagesDelivered
        - this.statistics.optedOutPersons;
    },
    percentDelivered() {
      return this.calcPercentage(
        this.statistics.messagesDelivered,
        this.statistics.totalPersons
      );
    },
    chartData() {
      return {
        labels: [this.$t('scheduler.delivered_messages'), ''],
        datasets: [
          {
            backgroundColor: [this.greenColor, this.greyColor],
            data: [
              this.statistics.messagesDelivered,
              this.notDelivered
              ]
          }
        ]
      }
    },
    chartEngagedPersonsData() {
      return {
        labels: [this.$t('scheduler.marketable'), 'Others'],
        datasets: [
          {
            backgroundColor: [this.greenColor, this.greyColor],
            data: [
              this.engagedPersons,
              this.statistics.totalPersons - this.engagedPersons
              ]
          }
        ]
      }
    },
    chartNotDeliveredData() {
      return {
        labels: [this.$t('scheduler.not_delivered'), 'Others'],
        datasets: [
          {
            backgroundColor: [this.redColor, this.greyColor],
            data: [
              this.notDelivered,
              this.statistics.totalPersons - this.notDelivered
              ]
          }
        ]
      }
    },
    chartInvalidNumbersData() {
      return {
        labels: [this.$t('scheduler.invalid_numbers'), 'Others'],
        datasets: [
          {
            backgroundColor: [this.redColor, this.greyColor],
            data: [
              this.statistics.totalInvalidNumbers,
              this.statistics.totalPersons - this.statistics.totalInvalidNumbers
              ]
          }
        ]
      }
    },
    optedOutPersonsChartData() {
      return {
        labels: [this.$t('scheduler.opted_out'), 'Others'],
        datasets: [
          {
            backgroundColor: [this.redColor, this.greyColor],
            data: [
              this.statistics.optedOutPersons,
              this.statistics.totalPersons - this.statistics.optedOutPersons
              ]
          }
        ]
      }
    }
  },
  data() {
    return {
      greenColor: '#41b883',
      greyColor: '#a6a6a6',
      redColor: '#dc3545',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        borderWidth: 0,
        cutout: '70%',
        plugins: {
          legend: {
            display: false
          },
        }
      },
      smallChartOptions: {
        responsive: true,
        circumference: 180,
        rotation: -90,
        maintainAspectRatio: false,
        borderWidth: 0,
        cutout: '70%',
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
        }
      }
    }
  },
  methods: {
    calcPercentage(partial, from) {
      return Math.round((partial / from) * 100);
    }
  }
}
</script>
<style>
  .donut-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
